module.exports = __webpack_public_path__ + "img/ad-title-img.e0bf9927.png";